<template>
  <el-button :style="{ 'font-size': fontSize + 'px' }" type="text" @click="linkToOrderDetail">
    {{ orderNo }}
  </el-button>
</template>

<script>
export default {
  name: 'userInfo',
  props: {
    orderType: [String, Number],
    orderNo: [String, Number],
    orderId: [String, Number],
    fontSize: {
      type: [String, Number],
      default: 12
    }
  },
  methods: {
    linkToOrderDetail() {
      if (this.orderType == 2) {
        this.$openRef(`/ordercenter/detail/${this.orderId}`)
      } else if (this.orderType == 5) {
        this.$openRef(`/ordercenter/takeoutDetail/${this.orderId}`)
      } else if (this.orderType == 6) {
        this.$openRef(`/application/markeActivitie/sendCouponDetail/${this.orderId}`)
      } else if (this.orderType == 7) {
      } else if (this.orderType == 8) {
        this.$openRef(`/ordercenter/washCareDetail/${this.orderId}`)
      } else if (this.orderType == 12) {
        this.$openRef(`/ordercenter/housekeepingDetail/${this.orderId}?orderId=${this.orderId}`)
      }
    }
  }
}
</script>

<style lang="less" scoped></style>
